"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffsetPseudoButton = exports.ContentWrapper = exports.StyledMenuDesktop = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _button = require("../../../styles/2_commonComponentStyles/button");

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledMenuDesktop = _styledComponents.default.div.withConfig({
  displayName: "MenuDesktopstyles__StyledMenuDesktop",
  componentId: "sc-7j987f-0"
})(["align-items:center;box-shadow:", ";display:flex;flex-direction:row;height:", ";justify-content:space-between;width:100%;z-index:", ";"], function (props) {
  return props.theme.s_menu;
}, function (props) {
  return props.theme.desktopMenuHeight;
}, function (props) {
  return props.theme.menu;
});

exports.StyledMenuDesktop = StyledMenuDesktop;

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "MenuDesktopstyles__ContentWrapper",
  componentId: "sc-7j987f-1"
})(["display:flex;flex:1;justify-content:flex-start;padding-left:", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 3, props.theme.standardPadding);
});

exports.ContentWrapper = ContentWrapper;
var OffsetPseudoButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "MenuDesktopstyles__OffsetPseudoButton",
  componentId: "sc-7j987f-2"
})(["position:relative;right:-", ";&:not(:last-child){margin-right:", ";}"], _button.fitTextPadding, function (props) {
  return props.theme.standardPadding;
});
exports.OffsetPseudoButton = OffsetPseudoButton;